import styled from "@emotion/styled";

export const StyledStepperContainer = styled("div")`
  width: 100%;
  height: 100%;
  margin-top: 40px;
  margin-bottom: 40px;
`;
